import React from 'react';
import Icon from "antd/lib/icon";

const BlockConcept = (props) => {
  const rowStyle = { 
    display: "flex",
    justifyContent: "space-between",
    marginTop: "5px",
    marginBottom: "20px"
  };

  const columnStyle = {
    display: "flex",
    flexDirection: "column"
  }

  const blockText = {
    fontSize: "8pt"
  }

  return (
    <div>
      <p className="step-p">Each block stores the following information:</p>

      <div style={rowStyle}>
        <div style={columnStyle}>
          <Icon type="tag-o"/>
          <div style={blockText}>Index</div>
        </div>

        <div style={columnStyle}>
          <Icon type="calendar"/>
          <div style={blockText}>Timestamp</div>
        </div>

        <div style={columnStyle}>
          <Icon type="barcode"/>
          <div style={blockText}>Hash</div>
        </div>

        <div style={columnStyle}>
          <Icon type="step-backward"/>
          <div style={blockText}>Previous Hash</div>
        </div>

        <div style={columnStyle}>
          <Icon type="file-text"/>
          <div style={blockText}>Data</div>
        </div>

        <div style={columnStyle}>
          <Icon type="tool"/>
          <div style={blockText}>Nonce</div>
        </div>
      </div>
    </div>
  );
};

export default BlockConcept;


// WEBPACK FOOTER //
// ./src/steps/block/block-concept.js